"use client";
import BanerSection from "./BanerSection";
import IntroSection from "./IntroSection";
import ProductsSection from "./ProductsSection";
import { Container } from "@mui/material";
import { OrderAuthModal } from "@/src/components/OrderAuthModal";
import { Suspense } from "react";

export const HomePage = ({ banners }: any) => {
  return (
    <div className="bg-white">
      <Suspense fallback={<div />}>
        <BanerSection sectionProps={{ className: "pt-0" }} banners={banners} />
      </Suspense>
      <ProductsSection />
      <section className={"py-16 max-md:py-10"}>
        <Container>
          <IntroSection />
        </Container>
      </section>
      <Suspense fallback={<div />}>
        <OrderAuthModal />
      </Suspense>
    </div>
  );
};
